module.exports = __webpack_public_path__ + "img/a.d3675aef.png";